// istanbul ignore file
import styled from 'styled-components';

export const MultiApplicationsInlineButtonWrapper = styled.div`
  margin: 0 ${(props) => props.theme.spacing.xs};
`;

export const SingleApplicationInlineButtonWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.spacing.xs};
  padding: 0 ${(props) => props.theme.spacing.xxs};
`;
